import { render, staticRenderFns } from "./PasswordSettings.vue?vue&type=template&id=9997a53a"
import script from "./PasswordSettings.vue?vue&type=script&lang=js"
export * from "./PasswordSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports